import { FormSelectYesNo } from '../../formelements'

export const AuthMedica = ({ auth, handleChange, error }) => {

    return (<>
        <div className="row">
            <div className="col col-12 ">
                <h4>
                    Autorització mèdica
                </h4>
                <p>
                    <label htmlFor="authMedica"> AUTORITZO en cas que es produís una urgència mèdica imprevista greu i l'Institut l'hagués d'acompanyar a un centre mèdic, mentre no arriba la família, autoritzo el professor acompanyant a prendre totes les decisions oportunes (proves, anàlisis, transfusions ...). </label>
                    <br/>
                    <br/>
                     <FormSelectYesNo
                            id="authMedica"
                            name="authMedica"
                            col="col-12"
                            label="Trieu una opció:"
                            obligatori={true}
                            value={auth}
                            handleChange={(e) => handleChange(e.target.value) } 
                            error={error}
                            />
                    <span id="auhtMedica_ERROR" className="a-Form-error">{error}</span>
                </p>

            </div>
        </div>

        <br />
    </>)

}